import { Mapper } from '../base-mapper';
import { KIM_PP_RISKS } from '@/utils/constants';
import type { KimPushPullReport } from '@/types/KimPP';
import type { GetKimPPReportResponseDTO } from '@/core/dto/kim-pp';

export class KimPPReportMapper implements Mapper<KimPushPullReport> {
	constructor(private readonly data: GetKimPPReportResponseDTO) {}

	private getResult(): number {
		const riskLabel = this.data?.labels?.risk.value;
		const riskIndex = Object.keys(KIM_PP_RISKS).findIndex((key) => key === riskLabel);
		const result = riskIndex + 1;
		return result;
	}

	toDomain(): KimPushPullReport {
		return {
			...this.data,
			result: this.getResult()
		};
	}
}
